var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60.6 60.6"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_svg__a",
    x1: "0%",
    y1: "50%",
    x2: "50%",
    y2: "0%",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef5ba1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#7f3f98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_svg__b",
    x1: "0%",
    y1: "50%",
    x2: "50%",
    y2: "0%",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f15a22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#faa61a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_svg__c",
    x1: "28%",
    y1: "28%",
    x2: "68%",
    y2: "68%",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a0386c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#ef5ba1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f05b72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#f15a22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9f3a0d"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3 35.2a7.85 7.85 0 0011 0l18.1-18.1 6.2 6.2V0H37.3l6.2 6.2-18.2 18a7.85 7.85 0 000 11z",
    fill: "#485e88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3 15.2L31.4 0H12.1A12.08 12.08 0 000 12.06v23A12 12 0 013.5 28z",
    fill: "url(#icon_svg__a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4 44.3l15.2-15.2v19.3a12.08 12.08 0 01-12.06 12.1h-23a11.85 11.85 0 007.1-3.4z",
    fill: "url(#icon_svg__b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3 44.3a20.64 20.64 0 010-29.1L3.5 28A12.58 12.58 0 000 35.1v25.4h25.4a11.85 11.85 0 007.1-3.4l12.8-12.8a20.52 20.52 0 01-29 0z",
    fill: "url(#icon_svg__c)"
  })));
}
export default SvgIcon;